import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

const BookingCancel = () => {
    const [searchParams] = useSearchParams();
    const bookingId = searchParams.get('booking_id');
    const { settings } = useSettings();
    const waPhone = (settings.company_whatsapp || "+212771373922").replace(/[^0-9]/g, "");

    return (
        <div className="min-h-[60vh] flex items-center justify-center px-4 py-12">
            <div className="max-w-md w-full rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm dark:border-slate-800 dark:bg-slate-900">
                <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mx-auto mb-5">
                    <svg className="w-8 h-8 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">Payment Cancelled</h1>
                <p className="text-slate-600 dark:text-slate-400 mb-2">
                    Your payment was cancelled. No amount has been charged to your account.
                </p>
                <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
                    You can try again anytime - your information is safe.
                </p>

                {bookingId && (
                    <p className="text-xs text-slate-400 mb-6">
                        Reference: #{bookingId}
                    </p>
                )}

                <div className="space-y-3">
                    <Link
                        to="/tours"
                        className="block w-full bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition font-semibold"
                    >
                        Browse Tours & Try Again
                    </Link>
                    <Link
                        to="/"
                        className="block w-full border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-300 px-6 py-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition"
                    >
                        Back to Home
                    </Link>
                </div>

                <p className="text-sm text-slate-500 dark:text-slate-400 mt-6">
                    Need help?{' '}
                    <a
                        href={`https://wa.me/${waPhone}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-emerald-600 hover:underline"
                    >
                        Chat with us on WhatsApp
                    </a>
                </p>
            </div>
        </div>
    );
};

export default BookingCancel;
